import { FC, useState } from 'react';
import {
  AppBar,
  Badge,
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Container,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  Toolbar,
  Typography,
  useTheme
} from '@mui/material';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightFromBracket, faBars, faBook, faCalendar, faComment, faInfo, faTrophy } from '@fortawesome/free-solid-svg-icons';
import { Paths } from '../constants/paths.ts';
import { useNotifications } from '../contexts/notification.context.tsx';
import { trackEvent } from '../utils/analytics.ts';

export const BottomNavLayout: FC = () => {
  const { palette } = useTheme();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const { unreadMessages } = useNotifications();

  return (
    <>
      <AppBar position="static" sx={{ bgcolor: palette.primary.dark }}>
        <Toolbar>
          <img src="/logo.svg" alt="logo" style={{ height: 40, marginRight: 5 }} />
          <Typography variant="h4" component="div" color="primary" sx={{ flexGrow: 1 }}>
            ABLE
          </Typography>
          <IconButton
            onClick={() => {
              setOpen(true);
              trackEvent('nav_drawer_open');
            }}
          >
            <FontAwesomeIcon icon={faBars} color={palette.primary.main} />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Container sx={{ p: 2 }}>
        <Outlet />
      </Container>
      <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
        <BottomNavigation
          showLabels
          value={pathname}
          onChange={(_event, newValue) => {
            navigate(newValue);
            trackEvent('nav_bottom', { destination: newValue });
          }}
        >
          <BottomNavigationAction label="Acitivties" value={Paths.HOME} icon={<FontAwesomeIcon icon={faCalendar} size="2x" />} />
          <BottomNavigationAction
            label="Messages"
            value={Paths.MESSAGES}
            icon={
              <Badge color="error" badgeContent={unreadMessages}>
                <FontAwesomeIcon icon={faComment} size="2x" />
              </Badge>
            }
          />
          <BottomNavigationAction label="Achievements" value={Paths.ACHIEVEMENTS} icon={<FontAwesomeIcon icon={faTrophy} size="2x" />} />
        </BottomNavigation>
      </Paper>
      <Drawer open={open} onClose={() => setOpen(false)} anchor="right">
        <Box display="flex" flexDirection="column" sx={{ width: 250, minHeight: '100%' }} role="presentation" onClick={() => setOpen(false)}>
          <List>
            <ListItem
              onClick={() => {
                navigate(Paths.RESOURCES);
                trackEvent('nav_drawer_item', { destination: Paths.RESOURCES });
              }}
            >
              <ListItemButton>
                <ListItemIcon>
                  <FontAwesomeIcon icon={faBook} />
                </ListItemIcon>
                <ListItemText primary="Resources" />
              </ListItemButton>
            </ListItem>
            <ListItem
              onClick={() => {
                navigate(Paths.TUTORIAL, { state: Paths.HOME });
                trackEvent('nav_drawer_item', { destination: Paths.TUTORIAL });
              }}
            >
              <ListItemButton>
                <ListItemIcon>
                  <FontAwesomeIcon icon={faInfo} />
                </ListItemIcon>
                <ListItemText primary="Tutorial" />
              </ListItemButton>
            </ListItem>
          </List>
          <Box flexGrow={1} />
          <List>
            <Divider />
            <ListItem
              onClick={() => {
                navigate(Paths.LOGOUT);
                trackEvent('nav_drawer_item', { destination: Paths.LOGOUT });
              }}
            >
              <ListItemButton>
                <ListItemIcon>
                  <FontAwesomeIcon icon={faArrowRightFromBracket} />
                </ListItemIcon>
                <ListItemText primary="Logout" />
              </ListItemButton>
            </ListItem>
          </List>
        </Box>
      </Drawer>
    </>
  );
};
